import React, { useEffect, useState } from "react";
import { Search as SearchIcon } from "lucide-react";
import { api } from "../lib/api";
import Navbar from "../components/Navbar";
import MovieCard from "../components/MovieCard";
import Footer from "../components/Footer";

export default function SearchPage() {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setL] = useState(false);

  useEffect(() => {
    if (!q.trim()) { setResults([]); return; }
    const t = setTimeout(async () => {
      setL(true);
      try {
        const { data } = await api.get("/videos/search", { params: { q } });
        setResults(data);
      } finally { setL(false); }
    }, 300);
    return () => clearTimeout(t);
  }, [q]);

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      <Navbar />
      <main className="pt-24 px-6 lg:px-12 max-w-[1600px] mx-auto">
        <div className="relative max-w-3xl mx-auto">
          <SearchIcon className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500 w-5 h-5" />
          <input
            data-testid="search-input"
            autoFocus
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search movies, shows, actors, genres..."
            className="input-dark pl-12 text-lg py-5"
          />
        </div>
        <div className="mt-10">
          {loading && <p className="text-gray-400 text-center">Searching...</p>}
          {!loading && q && results.length === 0 && (
            <p className="text-gray-400 text-center">No results for "{q}"</p>
          )}
          {!q && (
            <p className="text-gray-500 text-center">Start typing to discover titles.</p>
          )}
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4">
            {results.map((v) => (
              <MovieCard key={v.id} video={v} size="md" />
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
